const baseFitmentFields = window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model'];
const extraFitmentFields = window.Convermax.config?.extraFitmentFields || ['Submodel'];
const wheelsFields = window.Convermax.config?.wheelsFields || [
  'wheel_diameter',
  'wheel_width',
  'wheel_bolt_pattern',
];
const tiresFields = window.Convermax.config?.tiresFields || ['tire_width', 'tire_aspect', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields];

const isVehicleLanding = !!window.Convermax.config?.isVehicleLanding;
const vehicleLandingPageView = window.Convermax.config?.vehicleLandingPageView ?? 'products';

const handleCurrencies = (selector) => {
  if (window.Currency) {
    // window.Currency.cookie.read() can cause exception "Uncaught TypeError: jQuery.cookie is not a function"
    try {
      const currentCurrency = window.Currency?.cookie.read();
      window.Currency.convertAll(window.Convermax.Shopify.getCurrency(), currentCurrency, selector);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.debug(e.message);
    }
  }
};

const fieldsForRelated = ['category', ...wheelsFields, ...tiresFields];
function getSelection(itemData) {
  return fieldsForRelated.flatMap((field) => {
    const value = itemData[field];
    return !value
      ? []
      : Array.isArray(value)
        ? value.map((term) => ({ field, term }))
        : { field, term: value };
  });
}

const updateCallback = () => {
  handleCurrencies('.cm_SearchResult .price');

  if (window._affirm_config && window.affirm?.ui) {
    // affirm.ui.ready()/refresh() can throw internally (e.g. "undefined is not an object")
    // on pages without promo elements, or when a store's own affirm snippet is misconfigured.
    try {
      window.affirm.ui.ready(function () {
        try {
          window.affirm.ui.refresh();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.debug(`affirm.ui.refresh(): ${e.message}`);
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.debug(`affirm.ui.ready(): ${e.message}`);
    }
  }
};

const AfterInit = () => {
  const mobileBarContainer = document.querySelector('#mobile-bar .mobile-bar_list');
  if (mobileBarContainer) {
    const mobileBarElements = [...mobileBarContainer.childNodes];

    const isGarageAtTheBottom = mobileBarElements.some(
      (el) => el.id === 'cm-mobile-garage' && el.childNodes.length > 0,
    );

    if (isGarageAtTheBottom) {
      document.querySelector('.cm_garageDropdown').style.cssText = 'top: auto; bottom: 57px; left: -100px';
    }
  }
};

const addItemsToCart = async (ids, defaultsAddItemsToCart) => {
  if (ids?.length) {
    await defaultsAddItemsToCart(ids);
    window.location.assign('/cart');
  }
};

export default {
  platform: 'shopify',
  AfterInit,
  sortFields: [
    'relevance',
    'title',
    'title:desc',
    'collection_sort',
    'price',
    'price:desc',
    'published_at',
    'published_at:desc',
  ],
  infiniteScrollEnabled:
    !window.Convermax.config?.paginationType || window.Convermax.config.paginationType === 'infinite_scroll',
  addItemsToCart,
  SearchRequestDefaults: {
    pageSize: window.Convermax.config?.pageSize || 36,
    sort: window.Convermax.config?.defaultSort || 'relevance',
  },
  product: {
    searchResultsImageWidth: 380,
    searchResultsImageHeight: 380,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      {
        pathname: window.Convermax.Shopify?.getCollectionsPageUrl(),
        field: window.Convermax.config?.categorySelectionPageField ?? 'category',
      },
      {
        pathname: window.document.querySelector('#cm-brand-list') ? window.location.pathname : null,
        field: 'vendor',
      },
      {
        pathname:
          isVehicleLanding && vehicleLandingPageView === 'categories' ? window.location.pathname : null,
        field: 'category',
      },
    ],
    categorySelectionPageRedirect: !!window.Convermax.config?.categorySelectionPageRedirect,
    disableVehicleStorage: !!window.Convermax.config?.doNotSaveSelectedVehicle,
    forceVehicleSelection: !!window.Convermax.config?.forceVehicleSelection,
    isAutoRedirectDisabled: !!window.Convermax.config?.isAutoRedirectDisabled,
    hideVehicleFromUrl: !!window.Convermax.config?.hideVehicleFromUrl,
    hideVerifyOnCartItems: window.Convermax.config?.hideVerifyOnCartItems,
    vehicleDataExpires: window.Convermax.config?.vehicleDataExpires,
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '#cm-collection-page',
      template: 'SearchPage',
      visibleIf: () => !isVehicleLanding || vehicleLandingPageView === 'products',
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      location: '#cm-category-carousel-list, #cm-subcategory-list',
      template: 'facetTiles/subtitles',
      visibleIf: () =>
        (!isVehicleLanding || vehicleLandingPageView === 'products') &&
        window.location.pathname !== '/collections/vendors',
      view: 'carousel',
      facetField: 'category',
      excludeFieldPreselection: window.Convermax.config?.showTopLevelCategories ? 'collection_ids' : null,
      useFilterMode: window.Convermax.config?.useTilesFilterMode,
    },
    {
      name: 'CategoryPageCategoriesGrid',
      type: 'FacetTiles',
      location: '#cm-category-grid-list',
      template: 'facetTiles/subtitles',
      visibleIf: () =>
        (!isVehicleLanding || vehicleLandingPageView === 'products') &&
        window.location.pathname !== '/collections/vendors',
      view: 'grid',
      facetField: 'category',
      excludeFieldPreselection: window.Convermax.config?.showTopLevelCategories ? 'collection_ids' : null,
    },
    {
      name: 'CategoryPageBrandsGrid',
      type: 'FacetTiles',
      location: '#cm-brands-grid-list',
      template: 'facetTiles/subtitles',
      view: 'grid',
      facetField: 'vendor',
    },
    {
      name: 'CategoryPageBrandsCarousel',
      type: 'FacetTiles',
      location: '#cm-brands-carousel-list',
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'vendor',
      useFilterMode: window.Convermax.config?.useTilesFilterMode,
    },
    {
      name: 'CategoryPageCollectionsGrid',
      type: 'FacetTiles',
      location: '#cm-collections-grid-list',
      template: 'facetTiles/subtitles',
      view: 'grid',
      facetField: 'collections',
    },
    {
      name: 'CategoryPageCollectionsCarousel',
      type: 'FacetTiles',
      location: '#cm-collections-carousel-list',
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'collections',
      useFilterMode: window.Convermax.config?.useTilesFilterMode,
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'SearchResult',
      infiniteScrollDisabled: !!window.Convermax.config?.infiniteScrollDisabled,
      instantInfiniteScroll: !!window.Convermax.config?.instantInfiniteScroll,
      updateCallback,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    {
      name: 'SearchBox',
      location: '.header-content .header-search, .header-content .searchbox',
      template: 'SearchBox',
      onDropdownItemsReceived: () => handleCurrencies('.cm_search-box-root div.price'),
      visibleIf: () => window.Convermax?.config?.isSearchBoxEnabled,
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '.mobile-bar-content .mobile-bar_item.search, .mobile-layout-bar .search-button',
        class: 'mobile-bar_item search search-button searchbox',
        wrapper: 'li',
      },
      template: 'searchBox/dialogButtonMobile',
      visibleIf: () => window.Convermax?.config?.isSearchBoxEnabled,
    },
    {
      name: 'SearchBoxDialogButton_header',
      type: 'SearchBoxDialogButton',
      location: {
        firstChildOf: '.header-mobile .header-content_top .header-cart',
        class: 'cm_HeaderSearchBoxDialogButton',
      },
      template: 'searchBox/dialogButtonMobile',
      visibleIf: () =>
        window.Convermax?.config?.isSearchBoxEnabled && !window.document.querySelector('#mobile-bar'),
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: { selector: '#cm-ymm', class: 'container' },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 800,
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: '#cm-ymm-tab',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 800,
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: '#cm-wheel-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
      requestExtra: { doNotHideWheelsTiresFacets: true },
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: '#cm-tire-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: tiresFields,
      requestExtra: { doNotHideWheelsTiresFacets: true },
    },
    {
      name: 'SearchBox_tab',
      type: 'SearchBox',
      location: { selector: '#cm-search-tab', class: 'cm_search-box-root__tab' },
      template: 'SearchBox',
      disableDropdown: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      name: 'VehicleSpecs',
      type: 'VehicleWidget',
      fields: !!window.Convermax.config?.extraFieldsAsFilters && extraFitmentFields,
      visibleIf: () => !!window.Convermax.config?.extraFieldsAsFilters,
    },
    {
      name: 'Garage',
      location: { selector: '#cm-garage', class: 'cm_garage__desktop' },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: { selector: '#cm-mobile-garage', class: 'mobile-bar_item cm_garage__mobile' },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'SingleVehicleGarage',
      location: { selector: '#cm-single-garage', class: 'cm-single-garage' },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'MobileSingleVehicleGarage',
      type: 'SingleVehicleGarage',
      location: { selector: '#cm-mobile-single-garage', class: 'cm-mobile-single-garage' },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/collapsibleVerifyFitment',
      isAlwaysColumnLayout: true,
      initCollapsed: true,
    },
    {
      name: 'FitmentTable',
      location: '#cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: { selector: '#cm-collection-list', class: 'container' },
      template: 'facetTiles/hierarchicalContainer',
      isMultiLevel: !!window.Convermax.config?.categoriesIsMultiLevel,
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
    },
    {
      name: 'VehicleLandingPageCategoryTiles',
      type: 'FacetTiles',
      location: '#cm-collection-page',
      template: 'facetTiles/hierarchicalContainer',
      isMultiLevel: !!window.Convermax.config?.categoriesIsMultiLevel,
      visibleIf: () => isVehicleLanding && vehicleLandingPageView === 'categories',
    },
    {
      name: 'RelatedItems',
      location: '#cm-related-products',
      template: 'product/relatedItems',
      count: window.Convermax.config?.relatedItemsCount || 6,
      getSelection,
    },
    {
      name: 'BoughtTogether',
      type: 'BuyItemsTogether',
      location: '#cm-bought-together-products',
      template: 'product/boughtTogether',
      mode: 'BoughtTogether',
      count: window.Convermax.config?.boughtTogetherCount || 5,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialogVehicleSpecs',
      initCollapsed: window.Convermax.config?.facetDialogInitCollapsed ?? true,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
      onDropdownItemsReceived: () => handleCurrencies('.cm_search-box-root__dialog div.price'),
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
    },
    {
      name: 'AutoSyncVisualizationDialog',
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
  ],
};
